import { Controller, UseFormReturn } from "react-hook-form";
import { TimeOffCategoryPolicySchema } from "@/pages/settings/time-off/policy/TimeOffCategoryPolicyEdit.tsx";
import { useTranslation } from "react-i18next";
import { Box, DropdownSelect, ListItem, Stack, Title } from "@skailer-com/uikit";
import {
  ApiTimeOffPolicyCarryoverCycleDateType,
  getCarryoverDateTypes,
} from "@/types/time-off/time-off-policy.types.ts";
import { Datepicker } from "@/components/datepicker/Datepicker.tsx";
import { useEffect } from "react";

export interface TimeOffPolicyAccrualCyclesProps {
  formHook: UseFormReturn<TimeOffCategoryPolicySchema>;
}

export function TimeOffPolicyAccrualCycles({ formHook }: TimeOffPolicyAccrualCyclesProps) {
  const { t } = useTranslation();
  const {
    watch,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = formHook;

  const carryoverCycleDateType = watch("carryover_cycle_date_type");

  const isSpecificDate =
    carryoverCycleDateType === ApiTimeOffPolicyCarryoverCycleDateType.specific_date;

  useEffect(() => {
    if (!isSpecificDate) return;
    if (!getValues("carryover_cycle_date_data.date_first")) {
      setValue("carryover_cycle_date_data.date_first", new Date(new Date().getFullYear(), 0, 1));
    }
  }, [isSpecificDate, getValues, setValue]);

  return (
    <>
      <Stack>
        <Title header={t("time_off:accrual_cycles")} size={"xs"} paddingBottom />
        <Box variant={"border"}>
          <Stack className={"my-3"}>
            <Controller
              render={({ field: { value, onChange } }) => (
                <ListItem
                  layout={"two-columns"}
                  title={t("time_off:accrual_cycles")}
                  caption={t("time_off:accrual_cycles_caption")}
                  behavior={"card"}
                  valueSlot={
                    <DropdownSelect
                      showCaption={false}
                      value={value}
                      onChange={onChange}
                      options={getCarryoverDateTypes()}
                    />
                  }
                />
              )}
              control={control}
              name={"carryover_cycle_date_type"}
            />

            {carryoverCycleDateType == ApiTimeOffPolicyCarryoverCycleDateType.specific_date && (
              <Controller
                render={({ field: { value, onChange } }) => (
                  <Datepicker
                    showYearDropdown={false}
                    value={value}
                    onChange={onChange}
                    label={t("common:date")}
                    error={errors.carryover_cycle_date_data?.message}
                  />
                )}
                control={control}
                name={"carryover_cycle_date_data.date_first"}
              />
            )}
          </Stack>
        </Box>
      </Stack>
    </>
  );
}
